import React, { useEffect, useState } from 'react';
import { Lock } from 'lucide-react';

// Earnings unlock date — anchored to backend `BLACKOUT_UNLOCK_AT`.
const UNLOCK_AT = new Date('2027-04-01T00:00:00Z').getTime();

function diff() {
  const ms = Math.max(0, UNLOCK_AT - Date.now());
  const d = Math.floor(ms / 86_400_000);
  const h = Math.floor((ms % 86_400_000) / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  const s = Math.floor((ms % 60_000) / 1_000);
  return { d, h, m, s };
}

/** Compact locked-earnings countdown. Shows D/H/M/S until Apr 1 2027. */
export default function BlackoutCountdown({ amountUsd = 0, compact = false }) {
  const [t, setT] = useState(diff());
  useEffect(() => {
    const id = setInterval(() => setT(diff()), 1000);
    return () => clearInterval(id);
  }, []);
  const cell = (label, val) => (
    <div className="flex flex-col items-center">
      <span className="text-xl md:text-2xl font-black tabular-nums text-amber-300">{String(val).padStart(2, '0')}</span>
      <span className="text-[9px] uppercase tracking-wider text-amber-200/60">{label}</span>
    </div>
  );
  return (
    <div className={`rounded-2xl border border-amber-500/40 bg-gradient-to-br from-amber-900/30 via-neutral-900 to-neutral-900 ${compact ? 'p-4' : 'p-5'}`} data-testid="blackout-countdown">
      <div className="flex items-start gap-3">
        <div className="shrink-0 w-9 h-9 rounded-lg bg-amber-500/20 border border-amber-500/40 flex items-center justify-center">
          <Lock size={16} className="text-amber-300"/>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-widest text-amber-300/80 font-bold">Cash earnings locked</div>
          <div className="text-2xl md:text-3xl font-black text-amber-200 tabular-nums">${Number(amountUsd || 0).toFixed(2)}</div>
          <div className="text-[11px] text-amber-100/70 mt-0.5">Unlocks April 1, 2027</div>
        </div>
      </div>
      <div className="mt-4 grid grid-cols-4 gap-2 bg-black/30 rounded-xl p-3 border border-amber-500/20">
        {cell('Days', t.d)}
        {cell('Hours', t.h)}
        {cell('Min', t.m)}
        {cell('Sec', t.s)}
      </div>
    </div>
  );
}
